export function isMobile(breakpoint = 992) {
    if (window.innerWidth < breakpoint)
        return true;
    else
        return false;
}